var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{style:(_vm.style),attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"maxlength":_vm.maxLength},domProps:{"value":_vm.text},on:{"input":_vm.changeText}})}
var staticRenderFns = []

export { render, staticRenderFns }